import { apiFetch } from "../http";
const getErrorMessage = (data, fallback) => {
    if (!data)
        return fallback;
    return data.error || data.detail || data.message || fallback;
};
const buildQuery = ({ q, page, pageSize, usagePeriod, usageChannel, installation }) => {
    const params = new URLSearchParams();
    const searchQuery = String(q !== null && q !== void 0 ? q : "").trim();
    if (searchQuery)
        params.set("q", searchQuery);
    const pageNum = Number(page);
    if (Number.isFinite(pageNum) && pageNum > 0)
        params.set("page", String(Math.trunc(pageNum)));
    const pageSizeNum = Number(pageSize);
    if (Number.isFinite(pageSizeNum) && pageSizeNum > 0)
        params.set("page_size", String(Math.trunc(pageSizeNum)));
    if (usagePeriod)
        params.set("usage_period", usagePeriod);
    if (usageChannel && usageChannel !== "all")
        params.set("usage_channel", usageChannel);
    if (installation && installation !== "all")
        params.set("installation", installation);
    const query = params.toString();
    return query ? `?${query}` : "";
};
export async function getUsersManagement(params) {
    const query = buildQuery(params);
    const data = await apiFetch(`/travel/api/get_users_management/${query}`, {
        baseUrl: params.baseUrl,
        token: params.token,
        method: "GET",
        signal: params.signal
    });
    if ((data === null || data === void 0 ? void 0 : data.success) === false) {
        throw new Error(getErrorMessage(data, "Failed to load users management"));
    }
    return data;
}
export async function getUsersPresenceHistory(params) {
    const currentYear = new Date().getFullYear();
    const year = Math.max(2000, Math.min(currentYear, Math.trunc(Number(params.year) || currentYear)));
    const data = await apiFetch(`/travel/api/users_presence_history/?year=${year}`, {
        baseUrl: params.baseUrl,
        token: params.token,
        method: "GET",
        signal: params.signal,
    });
    if ((data === null || data === void 0 ? void 0 : data.success) === false || !Array.isArray(data === null || data === void 0 ? void 0 : data.items)) {
        throw new Error(getErrorMessage(data, "Failed to load users presence history"));
    }
    return data;
}
export async function toggleUserBlockManagement(params) {
    const data = await apiFetch(`/travel/api/user_block_toggle/`, {
        baseUrl: params.baseUrl,
        token: params.token,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            user_id: params.userId,
            is_blocked: params.isBlocked
        })
    });
    if ((data === null || data === void 0 ? void 0 : data.success) === false) {
        throw new Error(getErrorMessage(data, "Failed to toggle user block status"));
    }
    return data;
}
export async function deleteUserManagement(params) {
    const data = await apiFetch(`/travel/api/delete_user_management/${encodeURIComponent(params.userId)}/`, {
        baseUrl: params.baseUrl,
        token: params.token,
        method: "DELETE"
    });
    if ((data === null || data === void 0 ? void 0 : data.success) === false) {
        throw new Error(getErrorMessage(data, "Failed to delete user"));
    }
    return data;
}
export async function getTravelReturnEmailOverview(params) {
    const data = await apiFetch(`/travel/api/admin/travel-return-emails/`, {
        baseUrl: params.baseUrl,
        token: params.token,
        method: "GET",
    });
    if ((data === null || data === void 0 ? void 0 : data.success) === false)
        throw new Error(getErrorMessage(data, "Failed to load return emails"));
    return data;
}
export async function sendTravelReturnEmails(params) {
    const data = await apiFetch(`/travel/api/admin/travel-return-emails/send/`, {
        baseUrl: params.baseUrl,
        token: params.token,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({}),
    });
    if ((data === null || data === void 0 ? void 0 : data.success) === false)
        throw new Error(getErrorMessage(data, "Failed to send return emails"));
    return data;
}
export async function getNoTravelEmailOverview(params) {
    const data = await apiFetch(`/travel/api/admin/no-travel-emails/`, {
        baseUrl: params.baseUrl,
        token: params.token,
        method: "GET",
    });
    if ((data === null || data === void 0 ? void 0 : data.success) === false)
        throw new Error(getErrorMessage(data, "Failed to load no-travel emails"));
    return data;
}
export async function sendNoTravelEmails(params) {
    const data = await apiFetch(`/travel/api/admin/no-travel-emails/send/`, {
        baseUrl: params.baseUrl,
        token: params.token,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({}),
    });
    if ((data === null || data === void 0 ? void 0 : data.success) === false)
        throw new Error(getErrorMessage(data, "Failed to send no-travel emails"));
    return data;
}
export async function getAccountDeletionEmailOverview(params) {
    const data = await apiFetch(`/travel/api/admin/account-deletion-emails/`, {
        baseUrl: params.baseUrl,
        token: params.token,
        method: "GET",
    });
    if ((data === null || data === void 0 ? void 0 : data.success) === false)
        throw new Error(getErrorMessage(data, "Failed to load account deletion emails"));
    return data;
}
export async function sendAccountDeletionEmails(params) {
    const data = await apiFetch(`/travel/api/admin/account-deletion-emails/send/`, {
        baseUrl: params.baseUrl,
        token: params.token,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({}),
    });
    if ((data === null || data === void 0 ? void 0 : data.success) === false)
        throw new Error(getErrorMessage(data, "Failed to send account deletion emails"));
    return data;
}
export async function getPublicPreviewBudgetStatus(params) {
    const data = await apiFetch(`/travel/api/admin/public-preview-budget/`, {
        baseUrl: params.baseUrl,
        token: params.token,
        method: "GET",
    });
    if ((data === null || data === void 0 ? void 0 : data.success) === false)
        throw new Error(getErrorMessage(data, "Failed to load preview budget"));
    return data;
}
